import { type AxiosResponse } from 'axios'
import api from '../utils/api'

const getTaskById = async (taskId: string): Promise<AxiosResponse> => {
  return await api.get(`/api/tasks/${taskId}/`)
}

export {
  getTaskById
}
